'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var AlertsDrawerController = function AlertsDrawerController($scope, $rootScope, $filter, $state, alertsDrawerService, strategyConstants, dataRetrieverConstantsService, $q, $log, transitionSearchCriteriaService, $interpolate) {
  var linkReadOnlyView = $interpolate('<a href="#" data-uid="{{uid}}" class="readOnlyRule">{{linkText}}</a>');
  var NOT_FOUND_CLASS = 'alert-not-found-class';
  var rmMomentFormat = $filter('rmMomentFormat');
  var headerFormat = _.replace($scope.headerFormat, /date\(([\w,]+)\)/, function (m, propName) {
    var propertyNames = propName.split(',');
    if (propertyNames.length > 1) {
      for (var index = 0; index < propertyNames.length; index++) {
        if ($scope.entityData[propertyNames[index]]) {
          return rmMomentFormat($scope.entityData[propertyNames[index]], 'DATE_USER_SETTINGS');
        }
      }
    }
    return rmMomentFormat($scope.entityData[propName], 'DATE_USER_SETTINGS');
  });
  var getCellClassName = function getCellClassName(rowId, datafield) {
    return datafield === 'name' && $scope.alertsGridSettings.source[rowId].notFound === true ? [NOT_FOUND_CLASS] : [];
  };
  function updateGrid(data) {
    _.map(data.rules, function (rule) {
      if (!rule.createdBy) {
        rule.notFound = true;
        rule.name = '(alert rule entry deleted from the system)';
      }
    });
    $scope.alertsGridSettings.source = _.reverse(_.sortBy(data.rules, 'score'));
    $scope.goToButtonVisible = shouldGoToButtonBeVisible([]);
    _.forEach($scope.footerItemsFormat, function (itemFormat) {
      $scope.footerItems.push(_.template(itemFormat)(data));
    });
  }
  function shouldGoToButtonBeVisible(selectedRowsIndexes) {
    var selectedRules = selectedRowsIndexes.length === 0 ? $scope.alertsGridSettings.source : getSelectedRules();
    return _.filter(selectedRules, function (row) {
      return !row.notFound;
    }).length > 0;
  }
  $scope.gridHeaderCaption = _.template(headerFormat)($scope.entityData);
  $scope.gridId = 'alerts-drawer-grid';
  $scope.removeButtonVisible = false;
  $scope.goToButtonVisible = false;
  $scope.alertsGridSettings = {
    width: '100%',
    height: '100%',
    altrows: true,
    selectionmode: 'checkbox_multiplerowsadvanced',
    columns: [{
      text: 'Alert Name',
      dataField: 'name',
      cellsalign: 'left',
      align: 'center',
      cellclassname: getCellClassName,
      cellsrenderer: function cellsrenderer(row, columnfield, value, defaultHtml) {
        var currentRow = $scope.alertsGridSettings.source[row];
        var data = {
          uid: currentRow.technicalId,
          linkText: value
        };
        return defaultHtml.replace('>' + value + '<', '>' + linkReadOnlyView(data) + '<');
      }
    }, {
      text: 'Value',
      dataField: 'score',
      width: 60,
      cellsalign: 'center',
      align: 'center'
    }]
  };
  $scope.footerItems = [];
  alertsDrawerService.getAlerts($scope.entityData, $scope.screen, $scope.mode, $scope.reoptPreviewData).then(updateGrid);
  function getRuleTechnicalId(rule) {
    return rule.technicalId;
  }
  function getRuleCreatedBy(rule) {
    return rule.createdBy;
  }
  function getSelectedRules() {
    var selectedRowIndexes = $scope.alertsGridSettings.jqxGrid('selectedrowindexes') || [];
    return _.filter($scope.alertsGridSettings.source, function (el, ix) {
      return selectedRowIndexes.length === 0 || selectedRowIndexes.indexOf(ix) > -1;
    });
  }
  function getSelectedRulesIds(filterFunction) {
    return _.chain(getSelectedRules()).filter(filterFunction).map(getRuleTechnicalId).uniq().value();
  }
  function getRulesUserIds(filterFunction) {
    return _.chain(getSelectedRules()).filter(filterFunction).map(getRuleCreatedBy).uniq().value();
  }
  function onRequestErrorHandler(response) {
    if (response.status === 409) {
      $log.error('AlertsDrawerController: onRequestErrorHandler - Data was already modified');
      toastr.error('Data was already modified');
    } else {
      toastr.error('Error clearing alerts');
    }
    updateGrids();
    return $q.reject();
  }
  function updateGrids() {
    $rootScope.$broadcast('grid:dataAndSelectionChangedGrid:' + $scope.parentGridId, [$scope.entityData]);
    if ($scope.parentGridId === 'class-flight-analysis' || $scope.parentGridId === 'segment-flight-analysis') {
      $rootScope.$broadcast('grid:setDeferredClear:cabin-flight-analysis');
    } else if ($scope.parentGridId === 'service-demand-analysis') {
      $rootScope.$broadcast('prepareTabsToReloadDataOnToggle', false, false);
    } else if ($scope.parentGridId === 'market-product-group-analysis') {
      $rootScope.$broadcast('prepareTabsToReloadDataOnToggle', false, true);
    }
  }
  function notDeletedRule(rule) {
    return !rule.notFound;
  }
  $scope.navigateToRules = function () {
    var selectedRulesIds = getSelectedRulesIds(notDeletedRule);
    var transitionData = {
      panel: strategyConstants.PANEL_TYPE.ALERTS
    };
    if ($scope.alertsGridSettings.source.length === 0) {
      transitionData.skipSearch = true;
    } else {
      var userIds = getRulesUserIds(notDeletedRule);
      transitionData.searchCriteria = transitionSearchCriteriaService.drawerToRules(userIds);
      transitionData.rulesIds = selectedRulesIds;
    }
    $state.go('app.rules', {
      transitionData: transitionData
    });
  };
  $scope.rowSelectionChanged = function () {
    var selectedRowsIndexes = $scope.alertsGridSettings.jqxGrid('selectedrowindexes');
    $scope.removeButtonVisible = selectedRowsIndexes.length > 0 && !$scope.isPreviewMode() && $scope.mode !== 'service-management';
    $scope.goToButtonVisible = shouldGoToButtonBeVisible(selectedRowsIndexes);
  };
  $scope.removeAlertsFromList = function () {
    var technicalIds = getSelectedRulesIds();
    $rootScope.$broadcast('grid:hideDrawerAndSetReopenFlag:' + $scope.parentGridId, 'alerts');
    alertsDrawerService.removeAlerts(technicalIds, $scope.entityData, $scope.screen, $scope.mode)["catch"](onRequestErrorHandler).then(updateGrids);
  };
  $scope.isPreviewMode = function () {
    return _.get($scope.reoptPreviewData, 'mdReopt.read', false) || _.get($scope.reoptPreviewData, 'ndReopt.read', false);
  };
};
AlertsDrawerController.$inject = ['$scope', '$rootScope', '$filter', '$state', 'AlertsDrawerService', 'StrategyConstants', 'DataRetrieverConstantsService', '$q', '$log', 'TransitionSearchCriteriaService', '$interpolate'];
module.exports = AlertsDrawerController;